module.exports = __webpack_public_path__ + "static/img/Group@2x-2.2065dae8.png";